import { Link } from "wouter";
import { getCurrentYear } from "@/lib/utils";

export default function Footer() {
  const currentYear = getCurrentYear();
  
  return (
    <footer className="bg-navy-gradient text-white py-16 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[rgba(125,155,118,0.05)] rounded-full -ml-32 -mt-32 opacity-20"></div>
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-[rgba(255,255,255,0.03)] rounded-full -mr-24 -mb-24"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          <div>
            <div className="mb-4">
              <img 
                src="/images/logos/SWaccounting.gif" 
                alt="SW Accounting Logo" 
                className="h-16 w-auto" 
              />
            </div>
            <p className="mb-4">Professional accounting services with over 20 years of experience helping businesses succeed.</p>
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://linkedin.com" 
                className="w-10 h-10 rounded-full bg-[rgba(255,255,255,0.1)] flex items-center justify-center hover:bg-[#7d9b76] transition-all duration-300 shadow-elegant" 
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=100054204701084" 
                className="w-10 h-10 rounded-full bg-[rgba(255,255,255,0.1)] flex items-center justify-center hover:bg-[#7d9b76] transition-all duration-300 shadow-elegant" 
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link href="/services#bookkeeping" className="hover:text-[#7d9b76] transition-all duration-300">Bookkeeping</Link></li>
              <li><Link href="/services#payroll" className="hover:text-[#7d9b76] transition-all duration-300">Payroll Automation</Link></li>
              <li><Link href="/services#tax" className="hover:text-[#7d9b76] transition-all duration-300">Sales Tax Filing</Link></li>
              <li><Link href="/services#reporting" className="hover:text-[#7d9b76] transition-all duration-300">Financial Reporting</Link></li>
              <li><Link href="/services#quickbooks" className="hover:text-[#7d9b76] transition-all duration-300">QuickBooks Setup</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link href="/" className="hover:text-[#7d9b76] transition-all duration-300">Home</Link></li>
              <li><Link href="/about" className="hover:text-[#7d9b76] transition-all duration-300">About Sarah</Link></li>
              <li><Link href="/testimonials" className="hover:text-[#7d9b76] transition-all duration-300">Testimonials</Link></li>
              <li><Link href="/booking" className="hover:text-[#7d9b76] transition-all duration-300">Book a Meeting</Link></li>
              <li><Link href="/login" className="hover:text-[#7d9b76] transition-all duration-300">Client Portal</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-serif font-bold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <i className="fas fa-envelope mr-2 text-[#7d9b76]"></i>
                <a href="mailto:sarah@swaccountingpro.com" className="hover:text-[#7d9b76] transition-all duration-300">
                  sarah@swaccountingpro.com
                </a>
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone mr-2 text-[#7d9b76]"></i>
                <a href="tel:8017916900" className="hover:text-[#7d9b76] transition-all duration-300">
                  801-791-6900
                </a>
              </li>
              <li className="flex items-start">
                <i className="fas fa-globe-americas mr-2 text-[#7d9b76] mt-1"></i>
                <div>
                  <span>Serving Clients</span>
                  <span> Nationwide</span>
                  <div itemScope itemType="https://schema.org/PostalAddress" className="text-sm text-white/60 mt-1">
                    Based in <span itemProp="streetAddress">1108 E Hackamore Dr</span>,<br/>
                    <span itemProp="addressLocality">Draper</span>, 
                    <span itemProp="addressRegion"> Utah</span> 
                    <span itemProp="postalCode"> 84020</span>
                  </div>
                </div>
              </li>
              <li className="flex items-start mt-4">
                <i className="fas fa-clock mr-2 text-[#7d9b76] mt-1"></i>
                <div itemScope itemType="https://schema.org/OpeningHoursSpecification">
                  <p>Monday - Friday: <span itemProp="opens">9:00 AM</span> - <span itemProp="closes">5:00 PM</span></p>
                  <p>Saturday - Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Appointment callout */}
        <div className="mt-12 mb-10 p-6 bg-[rgba(255,255,255,0.05)] rounded-xl shadow-elegant border border-[rgba(255,255,255,0.1)]">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <h4 className="font-serif text-xl font-bold">Ready to get started?</h4>
              <p className="text-white/80">Book a consultation today and take control of your finances.</p>
            </div>
            <Link 
              href="/booking"
              className="bg-[#7d9b76] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-md transition-all duration-300 shadow-elegant inline-flex items-center"
            >
              <i className="fas fa-calendar-alt mr-2"></i>
              Schedule Now
            </Link>
          </div>
        </div>
        
        <div className="border-t border-[rgba(255,255,255,0.1)] mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center">
            <p className="text-white/80">&copy; {currentYear} SW Accounting. All rights reserved.</p>
            <Link 
              href="/admin-login" 
              className="ml-3 text-white/40 hover:text-[#7d9b76] transition-all duration-300 text-xs"
              title="Admin Login"
            >
              <i className="fas fa-lock text-xs"></i>
            </Link>
          </div>
          <div className="mt-4 md:mt-0 space-x-6">
            <Link href="/privacy" className="hover:text-[#7d9b76] transition-all duration-300 text-white/80">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-[#7d9b76] transition-all duration-300 text-white/80">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
